
export const AccountType = {
  LawsonCard: 'LC',
  Account: 'A'
};

export class Account {
  idx: number;
  bank_name?: string;
  bank_code?: string;
  account_number?: string;
  account_holder?: string;
  customer_idx?: number;
  status?: number;
  account_type?: string;
  rc_idx?: number;
  is_deleted?: boolean;
}

export class ReceiverAccount extends Account {
  constructor(isNew?: boolean) {
    super();
    this.is_new = isNew;
  }
  is_new?: boolean;
  receiver_idx: number;
  charge_type?: string;
  branch_code: string;
  branch_name: string;
}

export class Contact {
  cc: string;
  company?: string;
  number: string;
}

export class FileInfo {
  idx: number;
  name: string;
  type: string;
  data: string;
  updateYn: boolean = false;
}

export class COI {
  id_num1: string;
  id_num2: string;
  id_exp1: string;
  id_exp2: string;
  type?: string = '';
  issue_date?: string;
  valid_date?: string;
  nationality?: string;
  personal_no?: string;
  serial_no?: string;

  imgList?: Array<FileInfo>;

  lic_no?: string;
  zip_code?: string;
  street?: string;
  street2?: string;
  issuer?: string;
  pass_no?: string;
  issue_country: string;
  pass_type?: string;
  expire_date: string;
  reg_no: string;

  ////////////// 추가 변수명
  residence_id?: string;
  idcard_id?: string;
  others_id?: string;
  company_id?: string;
  nat_region?: string;
  residence_status?: string;
  kyc_date?: string;
  kyc_remarks?: string;
  file_count?: number;
}

export class KTFCAccount {
  fintech_use_num: string;
  account_holder_name: string;
  bank_code_std: string;
  account_num: string;
  account_num_masked: string;
  transfer_agree_yn: string;
  inquiry_agree_yn: string;
}

export class KTFCUserInfo {
  user_ci: string;
  user_name: string;
  res_list: Array<KTFCAccount>;
  res_count: string;
  user_seq_no: string;
}

export class KYC {
  method?: string;
  postal_code?: string;
  status?: string;
  timestamp?: string;
  remarks?: string;
}
export class Token {
  access_token?: string;
  refresh_token?: string;
  expires_in?: string;
  token_type?: string;
  scope?: string;
  user_seq_no?: string;
  user_ci?: string;
}

export class User {
  idx?: string;
  id?: string;
  password?: string;
  accesscode?: string;
  firstname?: string;
  middlename?: string;
  lastname?: string;
  fullname?: string;
  phone1: string;
  phone2: string;
  birth?: string;
  gender?: string;
  nationality?: string;
  zip_code: string;
  street: string;
  street2: string;
  state?: string;
  city?: string;
  city2?: string;
  coi_type: string;
  score?: number;
  coi?: COI = new COI();
  docs?: Docs = new Docs();
  kyc?: KYC = new KYC();
  reg_date?: number;
  receiver?: Array<User>;
  coi_img_verified?: boolean;
}

export class Agent extends User {
  branch_code?: string;
  branch_name?: string;
  partner_id?: string;
  email?: string;
  phone?: string;
  name?: string;
  partner_name?: string;
  type?: string;
  remote_ip?: string;
  lastTime?: string;
  isDrm: boolean = false;
}

export class Customer extends User {
  branch_code?: string;
  branch_name?: string;
  customer_id?: string;
  agent_name?: string;
  agent_type?: string;
  ci?: string;
  user_token?: Token = new Token();
  signature?: string;
  privacy_date?: string;
  tos_date?: string;
  peps_confirm?: boolean;
  occupation?: string;
  kyc_fail_code?: string;
  kyc_fail_message?: string;
  kyc_fail_remark?: string;
  kyc_verify_code?: string;
  local_firstname?: string;
  local_middlename?: string;
  local_lastname?: string;
  country?: string;
  blocked?: boolean;
  account?: Array<Account> = new Array<Account>();
  acc_ls_limit_exceed?: boolean;
  selected_account_idx?: string;
  email?: string;
  // 추가

  kyc_method?: string;
  kyc_postal_code?: string;
  kyc_status?: string;
  kyc_date?: string;
  kyc_remarks?: string;
  registration_type?: string;
  my_number?: string;

  // individualSender
  sender_country?: string;
  number?: string;
  customer_type?: string = '';
  employment_type?: string;

  employer_name?: string;
  employer?: string;
  source_of_funds?: string;
  remarks?: string;

  recommender?: string;
  failed_count?: number;

  // CompanySender
  company_name?: string;
  company_number?: string;
  organization_type?: string;
  incoporation?: string;
  contact_email?: string;
  contact_number?: string;
  authorized_person_name?: string;
  resident_type?: string;
  registration_country?: string;

  doc_update_yn?: boolean;

  receivers?: Array<Receiver> = new Array<Receiver>();

  problemList?: Array<Customer>;

  canContinuable?: boolean;

  forceUpdate?: boolean;

  ext_name1?: string;
  ext_name2?: string;
  ext_name3?: string;

  agree?: AgreeList = new AgreeList();
  partner_customer_id?: string;

  has_txn_history?: boolean;

  email_yn?: string;
  kyc_status_idx?: number;

  coi_img_verified?: boolean;

  partner_id?: string;

  static initUserObjAlloc(obj: Customer) {
    obj.user_token = undefined;
    obj.account = undefined;
    obj.receivers = undefined;
    obj.agree = undefined;
    obj.customer_type = undefined;
    obj.coi = undefined;
    obj.docs = undefined;
    obj.kyc = undefined;
  }
}

export class AgreeList {
  privacy?: boolean;
  tos?: boolean;
}

export class IndividualSender extends Customer {
  sender_country: string;
  number: string;
  customer_type: string;
  employment_type: string;
  employer: string;
  occupation: string;
  source_of_funds: string;
  remarks: string;
}
export class CompanySender extends Customer {
  companyname: string;
  companynum: string;
  mynum: string;
  organization_type: string;
  incoporation: string;
  contact_email: string;
  contact_num: string;
  authorized: string;
  resident_type: string;
}

// 추가 클래스
export class Docs {
  count?: number;
  doc_1?: string;
  doc_2?: string;
  doc_3?: string;
  doc_4?: string;
  doc_5?: string;
  doc_6?: string;
  doc_7?: string;
  doc_8?: string;
  doc_9?: string;
  doc_10?: string;
  docList?: Array<FileInfo>;
}

export class Receiver extends User {
  phone: string;
  customer_idx: string;
  address: string;
  id_type: string;
  id_number: string;

  relation?: string;
  txnreason?: string;
  incomesource?: string;
  main_partner_id?: string;
  main_partner_name?: string;

  is_new?: boolean;

  account?: Array<ReceiverAccount> = new Array<ReceiverAccount>();

  /**
   * set undefined to coi, docs, kyc
   */
  public setNullNotUsed() {
    this.coi = undefined;
    this.docs = undefined;
    this.kyc = undefined;
  }

  static CloneForCreateTranaction = (obj: Receiver, validation?: boolean): Receiver => {
    const newObj = new Receiver();
    newObj.firstname = obj.firstname;
    newObj.lastname = obj.lastname;
    newObj.middlename = obj.middlename;
    newObj.phone = obj.phone;
    if (!validation) {
      newObj.gender = obj.gender;
      newObj.id_number = obj.id_number;
      newObj.id_type = obj.id_type;
      newObj.idx = obj.idx;
      newObj.address = obj.address;
      newObj.nationality = obj.nationality;
      newObj.street = obj.street;
      newObj.street2 = obj.street2;
      newObj.zip_code = obj.zip_code;
    }
    return newObj;
  }
}

export const KYCStatus = {
  Started: 'Started',
  Failed: 'Failed',
  Expired: 'Expired',
  Completed: 'Completed',
  Checking: 'Checking',
  Ready: 'Ready',
  Revoke: 'Revoke',
  InvalidIdCard: 'Invalid Id Card',
  Uploading: 'Uploading',
  AMLBlock: 'AMLBlock',
  ICC: 'ICC', // (Intensive Care Customer)
  CheckingAccDel: 'Checking Account Delete',
  Deactivated: 'Deactivated'
};

export class MergeCustomer {
  to_customer_idx: string;
  from_customer_idx: string;
}

export class KYCStatusList {
  list = KYCStatus;
  getList(type): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      if (type !== 'SELECT' &&
        ((type === 'AG' && val === 'Completed')
      || (type === 'ADR' && val === 'Completed')
      || val === 'Revoke' || val === 'CheckingAccDel' || val === 'Deactivated')) {
        continue;
      }
      ret.push(KYCStatus[val]);
    }
    return ret;
  }

  getKeyList(): Array<string> {
    return Object.keys(this.list);
  }
};

export const KYCMethod = {
  CounterVisit: 'Counter Visit',
  Event: 'By Event',
  App: 'By App'
};

// StaffVisit: 'Staff Visit',

export class KYCMethodList {
  list = KYCMethod;
  getList(): Array<string> {
    return Object.keys(this.list);
  }
};

export const KYCCustomerType = {
  Artist: 'Artist',
  BusinessManager: 'Business Manager',
  CulturalActivities: 'Cultural Activities',
  Dependent: 'Dependent',
  DesignatedActivities: 'Designated Activities',
  Diplomat: 'Diplomat',
  EngineerSpecialistinHumanitiesInternationalServices: 'Engineer/Specialist in Humanities/International Services (ESI)',
  Entertainer: 'Entertainer',
  HighlySkilledForeignProfessional: 'Highly Skilled Foreign Professional (HSFP)',
  HighlySkilledProfessional: 'Highly Skilled Professional (HSP)',
  Instructor: 'Instructor',
  IntracompanyTransferee: 'Intra-company Transferee',
  InvestorBusinessManager: 'Investor/Business Manager',
  Japanese: 'Japanese',
  Journalist: 'Journalist',
  LegalAccountingServices: 'Legal/Accounting Services',
  LongTermResident: 'Long Term Resident',
  MedicalServices: 'Medical Services',
  NursingCare: 'Nursing Care',
  Official: 'Official',
  PermanentResident: 'Permanent Resident',
  Professor: 'Professor',
  ReligiousActivities: 'Religious Activities',
  Researcher: 'Researcher',
  SkilledLabor: 'Skilled Labor',
  SpecifiedSkilledWorker: 'Specified Skilled Worker (SSW)',
  SpouseorChildofJapaneseNationals: 'Spouse or Child of Japanese Nationals',
  SpouseorChildofPermanentResidence: 'Spouse or Child of Permanent Residence',
  Student: 'Student',
  TechnicalInternTraining: 'Technical Intern Training (TIT)',
  TemporaryVisitor: 'Temporary Visitor',
  Trainee: 'Trainee',
};

export class KYCCustomerTypeList {
  list = KYCCustomerType;
  getList(): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      ret.push(KYCCustomerType[val]);
    }
    return ret;
  }
};

export const KYCOccupation = {
  Accountant: 'Accountant',
  Agriculture_worker: 'Agriculture worker',
  Business: 'Business',
  Consultant_and_specialist: 'Consultant and specialist',
  Engineer: 'Engineer',
  House_Wife: 'House Wife',
  IT_manager: 'IT manager',
  Marketing_researcher: 'Marketing researcher',
  Others: 'Others',
  Part_timer: 'Parttimer',
  Salary_man: 'Salaryman',
  Sales_person: 'Sales person',
  Student: 'Student',
  Trainee: 'Trainee',
  UNEMPLOYED: 'UNEMPLOYED',
  
  CEO: 'CEO',
  Manufacturing_Worker: 'ManufacturingWorker',
  PRESIDENT: 'PRESIDENT',
  Professor: 'Professor',
  Self_Employed_and_Business: 'SelfEmployedandBusiness',
  Service_Supervisor: 'ServiceSupervisor',
  Service_Worker: 'ServiceWorker',
  Skilled_Labour: 'SkilledLabour',

  // koala list
  Agriculture_Fisheries_Forestry: 'Agriculture/Fisheries/Forestry',
  Informationtechnology: 'Information technology',
  Architecture_Engineering: 'Architecture/Engineering',
  Tourism_HotelServices: 'Tourism/Hotel Services',
  Cateringtrade: 'Catering trade',
  Faculty_Students: 'Faculty/Students',
  Wholesale_Retail: 'Wholesale/Retail',
  Financelease:  'Finance lease',
  Medicalhealth: 'Medical health',
  Occupation: 'Occupation',
  Transportation_Logistics: 'Transportation/Logistics',
  Legalservice:  'Legal service',
  Printing_Publishing:  'Printing/Publishing',
  Government_CivilServants:  'Government/Civil Servants',
  Telecommunications_Communications:  'Telecommunications/Communications',
  Accounting_Banking_InsuranceRealEstate: 'Accounting/Banking/Insurance Real Estate',
  PropertyManagement:  'Property Management',
  Consultingservices:  'Consulting services',
  Customerservice: 'Customer service',
  Importandexporttrade:  'Import and export trade',
  Investment_Securities:  'Investment/Securities',
  Publicutilities: 'Public utilities',
  Financialindustry: 'Financial industry'

};

export class KYCOccupationList {
  list = KYCOccupation;
  getList(): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      ret.push(KYCOccupation[val]);
    }
    return ret;
  }
};

export const KYCSourceOfFunds = {
  Business_Income: 'Business Income',
  Investment: 'Investment',
  Loan: 'Loan(Borrow from others)',
  Lottery: 'Lottery',
  // Others: 'Others',
  Part_time_job: 'Part time job',
  Salary: 'Salary',
  Savings: 'Savings',
  Pension: 'Pension'
};

export class KYCSourceOfFundsList {
  list = KYCSourceOfFunds;
  getList(): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      ret.push(KYCSourceOfFunds[val]);
    }
    return ret;
  }
};

export const COITypes = {
  CompanyReg: 'Company registration',
  DriverLicense: 'Driver\'s License',
  IdCard: 'My Number Card',
  JpPassport: 'Passport',
  ResidenceCard: 'Residence card',
  Others: 'Others'
};

export class COITypesList {
  list = COITypes;
  getList(type: string): Array<string> {
    const list = Object.keys(this.list);
    if (type === 'I') {
      return list.filter(data => data !== 'CompanyReg');
    } else {
      return list;
    }
  }
};

export const OrganizationTypes = {
  ServiceBusiness: 'Service Business',
  Trade: 'Trade',
  Manufacturer: 'Manufacturer',
  Other: 'Other'
};

export class OrganizationTypesList {
  list = OrganizationTypes;
  getList(): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      ret.push(OrganizationTypes[val]);
    }
    return ret;
  }
};

export class Sender extends User {
  phone: string;
  nationality: string;
  country: string;
  gender: string;
  customer_idx: string;
  address: string;
  id_type: string;
  id_number: string;
};

export const ReceiverIdType = {
  '01': 'Citizenship',
  '02': 'License',
  '03': 'Passport',
  '04': 'Others',
  '05': 'AliPayID'
};

export class ReceiverIdTypeList {
  list = ReceiverIdType;
  getKeys(type: string): Array<string> {
    const list = Object.keys(this.list);
    if (type !== 'fft') {
      list.splice(list.indexOf('05'), 1);
    }
    // const ret = new Array<string>();
    // for (const val of list) {
    //   ret.push(ReceiverIdType[val]);
    // }
    return list;
  }
};

export enum UserListQueryMode {
  Full, Minimized, MinAccounts,
  WithoutReceiver
}

export class UserListQueryModeInstance {
  static conv(mode: UserListQueryMode) {
    if (mode == UserListQueryMode.Full) {
      return 'full';
    } else if (mode == UserListQueryMode.Minimized) {
      return 'minimized';
    } else if (mode == UserListQueryMode.MinAccounts) {
      return 'min_accounts';
    } else if (mode == UserListQueryMode.WithoutReceiver) {
      return 'without_receiver';
    }
  }

}

export const UserType = {
  'AGENT': 'Agent',
  'SUPERAGENT': 'Super Agent',
  'EXTERNAL': 'External'
}

export class UserTypeList {
  list = UserType;
  getList(except_external: boolean): Array<string> {
    const list = Object.keys(this.list);
    const ret = new Array<string>();
    for (const val of list) {
      if (except_external && val === 'EXTERNAL') {
        continue;
      }
      ret.push(val);
    }
    return ret;
  }
}

export const PageEntrance = {
  CustomerList: 'customerlist',
  BankDepositList: 'bankdepositlist',
  ExpiredManage: 'expiredmanage',
  ManageAccountG: 'manageaccountG',
  ManageAccountLC: 'manageaccountLC',
};

export class PageEntranceInstance {
  static From(value: string): string {
    const list = Object.keys(PageEntrance);
    for (const key of list) {
      if (PageEntrance[key] === value) {
        return PageEntrance[key];
      }
    }
    return '';
  }
}


export interface CustomerSnsInfo {
  user_id_agent: string;
  sns_id: string;
  sns_type: string;
}


// WEBPACK FOOTER //
// ./src/app/model/shared/user/user.ts